import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileSave = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 12V11H11V12H7ZM9 10.5L7 8.5L7.7 7.8L8.5 8.6V6.5125H9.5V8.6L10.3 7.8L11 8.5L9 10.5ZM3 10C2.725 10 2.48958 9.90208 2.29375 9.70625C2.09792 9.51042 2 9.275 2 9V2C2 1.725 2.09792 1.48958 2.29375 1.29375C2.48958 1.09792 2.725 1 3 1H6.5L9.5 4V5.5125H6V10H3ZM6 4.5H8.5L6 2V4.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFileSave);
export default ForwardRef;
